import { Grid, VStack } from "@chakra-ui/react";
import { ModelLockBanner } from "@components/ui-kit/model-lock-banner";
import { t } from "@lingui/macro";
import { CreditAccountsCard } from "@src/components/modules/expenses/Create/components/credit-accounts-card";
import { Spinner } from "@src/components/ui-kit";
import { can } from "@src/utils/components/permissions";
import { observer } from "mobx-react-lite";
import React from "react";
import {
  BasicInfoCard,
  BudgetItemsCard,
  ExpenseDataCard,
  FilesCard,
  Footer,
  Header,
  SummaryCard,
} from "./components";
import { useFetchDependencies } from "./hooks";
import { useStore } from "./store";

export const Create = observer(function Create() {
  const store = useStore();
  const loadingDependencies = useFetchDependencies();

  if (loadingDependencies) {
    return <Spinner absolute />;
  }

  return (
    <React.Fragment>
      <Header />

      <ModelLockBanner
        mb="6"
        show={store.hasModelLock}
        loading={store.isUnlockingExpense}
        onClick={store.unlockExpense}
        canUnlock={can("expense_modelLock")}
        model={t`expense`}
      />

      <Grid
        alignItems="flex-start"
        templateColumns={{
          base: "1fr",
          md: "0.5fr 0.5fr",
        }}
      >
        <FilesCard />

        <Grid
          gap="4"
          minW={{
            base: "unset",
            md: "520px",
          }}
          mt={{ base: "4", md: "0" }}
          ml={{ base: "0", md: "4" }}
        >
          <BasicInfoCard />
          <ExpenseDataCard />
        </Grid>
      </Grid>

      <VStack w="full" mt="4" spacing="4">
        <BudgetItemsCard />
        <CreditAccountsCard store={store.creditAccountsCardStore} />
        <SummaryCard />
      </VStack>

      <ModelLockBanner
        mb="6"
        show={store.hasModelLock}
        loading={store.isUnlockingExpense}
        onClick={store.unlockExpense}
        canUnlock={can("expense_modelLock")}
        model={t`expense`}
      />

      <Footer />
    </React.Fragment>
  );
});
